<template>
<div class="chapter">
<div class="inner_page">
<p class="imagep"><span><a id="page_6"><img alt="" src="Images/Pt01_06_fig01.jpg"/></a></span></p><a id="page_6">
</a><h2 class="h2" id="part01"><a id="page_6"></a><a id="page_7"></a><a href="#/Text/Contents#rpart01">PART I: OVERVIEW</a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?42b2e87c